import { Route } from "react-router-dom";
import { Tag } from "antd";

import { PageLayout } from "../../layouts/page-layout/PageLayout";
import { DashboardPage } from "../llm-whisperer/pages/DashboardPage";
import { ApiKeyPage } from "../llm-whisperer/pages/ApiKeyPage";
import { ProfileSettingsPage } from "../llm-whisperer/pages/ProfileSettingsPage";
import { PlaygroundPage } from "../llm-whisperer/pages/PlaygroundPage";
import { OnboardProduct } from "../onboard-product/OnboardProduct";
import { PRODUCT_NAMES } from "../llm-whisperer/helper";

function useLlmWhispererRoutes() {
  const v1NavPill = (
    <Tag
      className="llmw-v1-pill"
      color="orange"
      onClick={() =>
        window.open("https://llmwhisperer.unstract.com/signin", "newwindow")
      }
    >
      Looking for LLM Whisperer v1?
    </Tag>
  );

  return (
    <Route
      path=""
      element={<OnboardProduct type={PRODUCT_NAMES.llmWhisperer} />}
    >
      <Route
        path=":orgName"
        element={<PageLayout topNavBarOptions={v1NavPill} />}
      >
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="api-keys" element={<ApiKeyPage />} />
        <Route path="account" element={<ProfileSettingsPage />} />
        <Route path="playground" element={<PlaygroundPage />} />
      </Route>
    </Route>
  );
}

export { useLlmWhispererRoutes };
